module.exports = __webpack_public_path__ + "img/image-thumb-4.d5bc8092.webp";